import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import search_white from "images/icons/icon_search_white_transparent.svg";
import search_grey from "images/icons/icon_search_grey.svg";

class SearchHeader extends PolymerElement {
  static get template() {
    return html`
      <style>
        #searchform {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 58px;
        }

        input {
          outline: 0;
        }

        .search-container {
          height: 55px;
          border: 0.5px solid #979797;
          border-radius: 5px;
          background-color: rgba(255, 255, 255, 1);
          position: relative;
        }

        .search-container input {
          width: 80%;
          color: #424242;
          font-size: 19.2px;
          letter-spacing: 0.24px;
          line-height: 42px;
          border-radius: 0;
          border: 0;
          background-color: #fff;
          padding: 0 0 0 56px;
          margin: 0 auto 0 0;
          background-repeat: no-repeat;
          background-position: 20px;
        }

        .search-container input::placeholder {
          color: #7f7f7f;
          opacity: 1;
        }

        .search-link-button {
          line-height: 55px;
          background-color: #f96d01;
          height: 55px;
          cursor: pointer;
          width: 143px;
          position: absolute;
          right: 0;
          top: 0;
          border-radius: 0 5px 5px 0;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .search-link-button img {
          margin-right: 15px;
        }

        .search-link-button p {
          color: white;
          font-size: 16px;
          font-weight: 600;
        }
      </style>
      <div class="search-container">
        <form method="GET" id="searchform" role="search" action="/webinar/search">
          <input
            type="text"
            name="s"
            minlength="3"
            value="{{keyword::input}}"
            autocomplete="off"
            placeholder="Silakan cari judul webinar disini"
            style="background-image:url([[iconSearchGrey]])"
          />
          <div class="search-link-button" on-click="onSerachWebinar">
            <img src$="[[iconSearchWhite]]" alt="alomedika" />
            <p>Cari</p>
          </div>
        </form>
      </div>
    `;
  }

  static get properties() {
    return {
      iconSearchWhite: {
        type: String,
        value: search_white,
      },
      iconSearchGrey: {
        type: String,
        value: search_grey,
      },
      keyword: {
        type: String,
        value: "",
      },
    };
  }

  onSerachWebinar() {
    window.location.href = `/webinar/search?s=${this.keyword}&page=1`;
  }
}
customElements.define("search-header", SearchHeader);
